import { useMutation } from 'react-query';
import {
  createCertificateAgreement,
  deleteCertificateAgreement,
} from './AgreementCertificate.service';
import { notification } from 'antd';
import notificationError from '@/utils/functions/notificationError';
import { CertificateCreateRequest } from './AgreementCertiifcate.types';
import { useQueryChanel } from '@/contexts/QueryChanelProvider';

export function useCreateCertificateAgreement() {
  const queryChanel = useQueryChanel();

  return useMutation(
    (obj: CertificateCreateRequest) => createCertificateAgreement(obj),
    {
      async onSuccess(_, data) {
        notification.success({
          message: 'Sucesso!',
          description: 'Arquivo criado com sucesso',
        });

        queryChanel({
          invalidateQueries: [['bankAccountSettings', data.bankAccountId]],
        });
      },

      onError: (error) => {
        notificationError(error);
      },
    },
  );
}

export function useRemoveCertificateAgreement() {
  const queryChanel = useQueryChanel();

  return useMutation(deleteCertificateAgreement, {
    async onSuccess(_, bankAccountId) {
      notification.success({
        message: 'Sucesso!',
        description: 'Arquivo deletado com sucesso',
      });

      queryChanel({
        invalidateQueries: [['bankAccountSettings', bankAccountId]],
      });
    },

    onError: (error) => {
      notificationError(error);
    },
  });
}
